"use strict";

exports.__esModule = true;
var _DevicePropertyElement = require("./DevicePropertyElement");
Object.keys(_DevicePropertyElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DevicePropertyElement[key]) return;
  exports[key] = _DevicePropertyElement[key];
});
var _DevicePropertyThumbnail = require("./DevicePropertyThumbnail");
Object.keys(_DevicePropertyThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DevicePropertyThumbnail[key]) return;
  exports[key] = _DevicePropertyThumbnail[key];
});
var _DevicePropertyFields = require("./DevicePropertyFields");
Object.keys(_DevicePropertyFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DevicePropertyFields[key]) return;
  exports[key] = _DevicePropertyFields[key];
});
var _DevicePropertyHeader = require("./DevicePropertyHeader");
Object.keys(_DevicePropertyHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DevicePropertyHeader[key]) return;
  exports[key] = _DevicePropertyHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});